import cp = require('child_process');
import path = require('path');
import { getBinPath, getToolsEnvVars, Position, Range, TextEdit } from './util';
import { TextDocument } from '@workbench-stack/language-core';


export class GoDocumentFormattingEditProvider {

    public provideDocumentFormattingEdits(document: TextDocument, options): Thenable<TextEdit[]> {
        let filename = document.fileName;
        let formatTool = 'goreturns';
        let formatFlags =  [];

        // We ignore the -w flag that updates file on disk because that would break undo feature
        if (formatFlags.indexOf('-w') > -1) {
            formatFlags.splice(formatFlags.indexOf('-w'), 1);
        }

        // Fix for https://github.com/Microsoft/vscode-go/issues/613 and https://github.com/Microsoft/vscode-go/issues/630
        if (formatTool === 'goimports' || formatTool === 'goreturns') {
            formatFlags.push('-srcdir', filename);
        }

        return this.runFormatter(formatTool, formatFlags, document).then(edits => edits, err => {
            if (err && err.startsWith('flag provided but not defined: -srcdir')) {
                console.log(formatTool);
                return Promise.resolve([]);
            }
            if (err) {
                console.log('err', err);
                return Promise.reject('Check the console in dev tools to find errors when formatting.');
            }
        });
    }

    private runFormatter(formatTool: string, formatFlags: string[], document: TextDocument): Thenable<TextEdit[]> {
        let formatCommandBinPath = getBinPath(formatTool);

        return new Promise<TextEdit[]>((resolve, reject) => {
            if (!path.isAbsolute(formatCommandBinPath)) {
                return reject();
            }

            let t0 = Date.now();
            let env = getToolsEnvVars();
            let stdout = '';
            let stderr = '';

            // Use spawn instead of exec to avoid maxBufferExceeded error
            const p = cp.spawn(formatCommandBinPath, formatFlags, { env });
            p.stdout.on('data', data => stdout += data);
            p.stderr.on('data', data => stderr += data);
            p.on('error', err => {
                if (err && (<any>err).code === 'ENOENT') {
                    return reject();
                }
            });
            p.on('close', code => {
                if (code !== 0) {
                    return reject(stderr);
                }

                // Return the complete file content in the edit.
                // VS Code will calculate minimal edits to be applied
                const fileStart = new Position(0, 0);
                const fileEnd = document.getPosition(document.text.length);
                const range = new Range(fileStart, fileEnd);
                const textEdits: TextEdit[] = [new TextEdit(range, stdout)];

                let timeTaken = Date.now() - t0;

                if (timeTaken > 750) {
                    console.log(`Formatting took too long(${timeTaken}ms). Format On Save feature could be aborted.`);
                }
                return resolve(textEdits);
            });
            p.stdin.end(document.getText());
        });
    }
}
